$small-min: 767px;

fccd-doctor-location-modal {
}
